var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 17.71C15.5061 17.617 15.4317 17.5064 15.381 17.3846C15.3302 17.2627 15.3041 17.132 15.3041 17C15.3041 16.868 15.3302 16.7373 15.381 16.6154C15.4317 16.4936 15.5061 16.383 15.5999 16.29L20.1899 11.71C20.2836 11.617 20.358 11.5064 20.4088 11.3846C20.4595 11.2627 20.4857 11.132 20.4857 11C20.4857 10.868 20.4595 10.7373 20.4088 10.6154C20.358 10.4936 20.2836 10.383 20.1899 10.29C20.0025 10.1037 19.749 9.99921 19.4849 9.99921C19.2207 9.99921 18.9672 10.1037 18.7799 10.29L14.1899 14.88C13.6281 15.4425 13.3125 16.205 13.3125 17C13.3125 17.795 13.6281 18.5575 14.1899 19.12L18.7799 23.71C18.9661 23.8947 19.2175 23.9989 19.4799 24C19.6115 24.0008 19.7419 23.9755 19.8638 23.9258C19.9856 23.876 20.0964 23.8027 20.1899 23.71C20.2836 23.617 20.358 23.5064 20.4088 23.3846C20.4595 23.2627 20.4857 23.132 20.4857 23C20.4857 22.868 20.4595 22.7373 20.4088 22.6154C20.358 22.4936 20.2836 22.383 20.1899 22.29L15.5999 17.71Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.5c37c03f1445ce7ba43461a59349fea4.svg";
export { ForwardRef as ReactComponent };